module.exports = __webpack_public_path__ + "static/media/file-img.a3e8b0a1.png";